/*
  Madison Center: "Favoritos" (corazón de la ficha del producto y lista en Mi cuenta). Pedido de Jonathan 2026-10-05.
  Lista APARTE de "Guardar para después".
  - Cliente con sesión: la lista vive en su cuenta, en el servidor guardados-madison (/apps/guardados/favoritos/...,
    firmado por Shopify). Lo que había marcado en este navegador antes de iniciar sesión se une a su cuenta.
  - Sin sesión: se guarda en este navegador (localStorage "madison.favoritos").
  Solo se guarda: número de variante, handle del producto y fecha. Lo usan snippets/madison-ficha-movil.liquid y
  sections/main-customers-account.liquid con window.MadisonFavoritos.
*/
(function () {
  if (window.MadisonFavoritos) return;
  var API = '/apps/guardados/favoritos';
  var LOCAL = 'madison.favoritos';
  var cache = null;

  function conSesion() {
    var cuenta = document.querySelector('.header__account-icon');
    return !!(cuenta && /\/account\/?$/.test(cuenta.getAttribute('href') || ''));
  }
  function leerLocal() {
    try { var l = JSON.parse(localStorage.getItem(LOCAL) || '[]'); return Array.isArray(l) ? l : []; } catch (e) { return []; }
  }
  function escribirLocal(lista) {
    try { localStorage.setItem(LOCAL, JSON.stringify(lista.slice(0, 100))); } catch (e) {}
  }
  function llamar(ruta, datos) {
    return fetch(API + '/' + ruta, {
      method: datos ? 'POST' : 'GET',
      headers: datos ? { 'Content-Type': 'application/json' } : {},
      body: datos ? JSON.stringify(datos) : undefined,
      credentials: 'same-origin'
    }).then(function (r) {
      var tipo = r.headers.get('Content-Type') || '';
      if (!r.ok || tipo.indexOf('json') < 0) throw new Error('servidor ' + r.status);
      return r.json();
    }).then(function (json) {
      if (!Array.isArray(json.productos)) throw new Error('respuesta');
      return json.productos;
    });
  }

  // La lista actual (con sesión: la de su cuenta, uniendo lo que había en este navegador)
  function lista() {
    if (cache) return cache;
    var local = leerLocal();
    if (!conSesion()) { cache = Promise.resolve(local); return cache; }
    cache = (local.length ? llamar('unir', { productos: local }) : llamar('lista'))
      .then(function (productos) { if (local.length) escribirLocal([]); return productos; })
      .catch(function () { return local; });
    return cache;
  }

  function agregar(variante, producto) {
    var item = { variante: String(variante), producto: producto, cantidad: 1, fecha: new Date().toISOString() };
    return lista().then(function (actual) {
      var nueva = [item].concat(actual.filter(function (p) { return p.producto !== producto; }));
      if (!conSesion()) { escribirLocal(nueva); cache = Promise.resolve(nueva); return nueva; }
      cache = llamar('guardar', item).catch(function () { escribirLocal(nueva); return nueva; });
      return cache;
    });
  }

  function quitar(producto) {
    return lista().then(function (actual) {
      var fuera = actual.filter(function (p) { return p.producto === producto; });
      var nueva = actual.filter(function (p) { return p.producto !== producto; });
      if (!conSesion()) { escribirLocal(nueva); cache = Promise.resolve(nueva); return nueva; }
      cache = fuera.reduce(function (promesa, p) {
        return promesa.then(function () { return llamar('quitar', { variante: p.variante }); });
      }, Promise.resolve(nueva)).catch(function () { return nueva; });
      return cache;
    });
  }

  function tiene(producto) {
    return lista().then(function (l) { return l.some(function (p) { return p.producto === producto; }); });
  }

  // Aviso abajo de la pantalla
  var temporizador;
  function aviso(texto) {
    var el = document.querySelector('.madison-fav-aviso');
    if (!el) {
      el = document.createElement('div');
      el.className = 'madison-fav-aviso';
      el.setAttribute('role', 'status');
      el.style.cssText = 'position:fixed;left:16px;right:16px;bottom:96px;z-index:2147483000;display:flex;align-items:center;gap:10px;' +
        'padding:14px 16px;border-radius:14px;background:#1F2547;color:#fff;font-size:15px;line-height:1.3;box-shadow:0 8px 24px rgba(0,0,0,.25);' +
        'opacity:0;transform:translateY(16px);transition:opacity .2s,transform .2s;pointer-events:none;max-width:480px;margin:0 auto;';
      document.body.appendChild(el);
    }
    el.innerHTML = '<svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true" style="flex:0 0 22px"><path d="M12 21s-7.5-4.6-9.6-9.3C.9 8.3 3 4.5 6.7 4.5c2.2 0 3.6 1.2 5.3 3.1 1.7-1.9 3.1-3.1 5.3-3.1 3.7 0 5.8 3.8 4.3 7.2C19.5 16.4 12 21 12 21z" fill="#6C8CFF"/></svg><span></span>';
    el.querySelector('span').textContent = texto;
    requestAnimationFrame(function () { el.style.opacity = '1'; el.style.transform = 'translateY(0)'; });
    clearTimeout(temporizador);
    temporizador = setTimeout(function () { el.style.opacity = '0'; el.style.transform = 'translateY(16px)'; }, 2600);
  }

  window.MadisonFavoritos = { lista: lista, agregar: agregar, quitar: quitar, tiene: tiene, aviso: aviso, conSesion: conSesion };
})();
